import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({ styles, children, to }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`py-4 px-6 font-poppins font-medium text-[18px] text-primary bg-blue-gradient rounded-[10px] outline-none ${styles}`}
      onClick={() => to && navigate(to)}
    >
      {children || "Be a Sponsor"}
    </button>
  );
};

export default Button;
